import React from "react";
import { useIsOn } from "@hooks/useFeatureToggle";
import { Tab } from "../Tab";
import "./index.css";
import { useTranslation } from "react-i18next";
import { FEATURE_TOGGLES } from "@lib/featureToggles";

export const Header: React.FC = () => {
  const { t } = useTranslation();

  const isTitleCalendarDashboardEnabled = useIsOn(
    FEATURE_TOGGLES.TITLE_CALENDAR_DASHBOARD,
  );

  if (!isTitleCalendarDashboardEnabled) {
    return null;
  }

  return (
    <header className="dashboard-widgets__header">
      <h1 className="dashboard-widgets__header-title heading-1">
        {t("label.build_ecommerce_of_the_future")}
      </h1>
      <Tab />
    </header>
  );
};
